import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button, SvgIcon } from '../../../design-system';
import { FlowChartIcon } from '../../../design-system/Icons';

const ProjectsBlock = ({ projects, playbookId }) => {
    const navigate = useNavigate();
    const location = useLocation();

    if (!projects?.length) {
        return <></>;
    }

    const handleNav = (route) => navigate(route, { state: { from: location } });

    return (
        <div>
            <h3 className="font-heading-regular font-semibold text-[16px] text-black mb-5">
                Projects
            </h3>

            <div className="flex flex-col gap-3">
                {projects.map((project) => {
                    const { id, name, description } = project;

                    return (
                        <div
                            key={id}
                            className="max-w-full px-4 py-3 flex items-center justify-between gap-2 lg:gap-4 border-1 border-neutral-200 rounded-2 overflow-hidden"
                        >
                            <div className="overflow-hidden">
                                <div className="flex items-start gap-2 mb-0.5">
                                    <SvgIcon color="#1F2125" icon={FlowChartIcon} size="medium" />
                                    <p className="flex items-center font-body-bold text-body-bold-xs text-black min-h-[16px]">
                                        {name}
                                    </p>
                                </div>

                                <p className="font-body text-body-regular-xs text-neutral-500 truncate">
                                    {description}
                                </p>
                            </div>

                            <div className="max-w-min xs:min-w-fit">
                                <Button
                                    type="link"
                                    size="xs"
                                    text="Start Project"
                                    onClick={() => handleNav(`/playbook/${playbookId}/start/${id}`)}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ProjectsBlock;
